
import { Info } from "lucide-react";
import * as Icons from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { categoryIcons, categoryLabels, Insight } from "@/utils/insights-utils";

interface InsightCardProps {
  insight: Insight;
}

export const InsightCard = ({ insight }: InsightCardProps) => {
  const IconComponent = (Icons[categoryIcons[insight.category] as keyof typeof Icons] as React.FC<{ className?: string }>);

  return (
    <div className="flex gap-4 p-4 bg-gray-50 rounded-lg">
      <div className="text-primary">
        <IconComponent className="h-5 w-5" />
      </div>
      <div>
        <div className="font-medium text-sm text-primary mb-1">
          {categoryLabels[insight.category]}
        </div>
        <p className="text-gray-700">{insight.insight}</p>
        <div className="mt-2 text-sm text-gray-500 flex items-center gap-1">
          <span>Confidence Score: {(insight.confidence_score * 100).toFixed(0)}%</span>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <Info className="h-4 w-4 text-gray-400 cursor-help" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="max-w-xs text-sm">
                  The confidence score indicates how certain AIMAA is about this insight based on the assessment data. Higher scores (closer to 100%) suggest stronger confidence in the recommendation.
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
    </div>
  );
};
